/**
 * Moteur générique de la carte interactive.
 * Ne contient aucune URL en dur : tout est calculé à partir de
 * window.WORLD_MAP_ALL_COUNTRIES et window.WORLD_MAP_PUBLISHED_COUNTRIES
 * (countries-data.js), plus le paramètre "theme" reçu par init().
 * Réutilisable pour les 7 pages (guide, meteo, geographie, culture, tradition,
 * gastronomie, activite) sans dupliquer la moindre donnée ni URL : seul le nom
 * du thème change d'un appel à l'autre.
 */
(function (window) {
  "use strict";

  function touchDistance(a, b) {
    var dx = a.clientX - b.clientX;
    var dy = a.clientY - b.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function touchMidpoint(a, b) {
    return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 };
  }

  function initZoomPan(root, svg) {
    if (!svg.viewBox.baseVal.width) return;

    var initial = {
      x: svg.viewBox.baseVal.x,
      y: svg.viewBox.baseVal.y,
      width: svg.viewBox.baseVal.width,
      height: svg.viewBox.baseVal.height
    };
    var maxScale = 25; // assez pour distinguer le Vatican/Monaco/Saint-Marin
    var minWidth = initial.width / maxScale;

    var state = { suppressClick: false };

    function clampViewBox(vb) {
      vb.width = Math.min(initial.width, Math.max(minWidth, vb.width));
      vb.height = vb.width * (initial.height / initial.width);
      vb.x = Math.min(initial.x + initial.width - vb.width, Math.max(initial.x, vb.x));
      vb.y = Math.min(initial.y + initial.height - vb.height, Math.max(initial.y, vb.y));
      return vb;
    }

    function setViewBox(vb) {
      svg.setAttribute("viewBox", vb.x + " " + vb.y + " " + vb.width + " " + vb.height);
    }

    function zoomAround(vb, clientX, clientY, factor) {
      var rect = svg.getBoundingClientRect();
      var ratioX = (clientX - rect.left) / rect.width;
      var ratioY = (clientY - rect.top) / rect.height;
      var pointX = vb.x + ratioX * vb.width;
      var pointY = vb.y + ratioY * vb.height;

      var next = clampViewBox({ width: vb.width * factor, height: vb.height * factor, x: 0, y: 0 });
      next.x = pointX - ratioX * next.width;
      next.y = pointY - ratioY * next.height;
      clampViewBox(next);
      return next;
    }

    // --- Molette (desktop) ---
    root.addEventListener(
      "wheel",
      function (e) {
        e.preventDefault();
        var zoomFactor = e.deltaY < 0 ? 0.88 : 1 / 0.88;
        setViewBox(zoomAround(svg.viewBox.baseVal, e.clientX, e.clientY, zoomFactor));
      },
      { passive: false }
    );

    // --- Glisser à la souris (desktop) ---
    var dragging = false;
    var dragMoved = false;
    var start = { x: 0, y: 0 };
    var startViewBox = null;

    function beginPan(clientX, clientY) {
      dragging = true;
      dragMoved = false;
      start.x = clientX;
      start.y = clientY;
      var vb = svg.viewBox.baseVal;
      startViewBox = { x: vb.x, y: vb.y, width: vb.width, height: vb.height };
      root.classList.add("wm-dragging");
    }

    function movePan(clientX, clientY) {
      var dx = clientX - start.x;
      var dy = clientY - start.y;
      if (!dragMoved && Math.abs(dx) < 4 && Math.abs(dy) < 4) return;
      dragMoved = true;
      state.suppressClick = true;

      var rect = svg.getBoundingClientRect();
      var scaleX = startViewBox.width / rect.width;
      var scaleY = startViewBox.height / rect.height;
      var next = clampViewBox({
        x: startViewBox.x - dx * scaleX,
        y: startViewBox.y - dy * scaleY,
        width: startViewBox.width,
        height: startViewBox.height
      });
      setViewBox(next);
    }

    function endPan() {
      dragging = false;
      root.classList.remove("wm-dragging");
      // Laisse le temps à l'event "click" (qui suit "mouseup"/"touchend") de lire le flag.
      setTimeout(function () {
        state.suppressClick = false;
      }, 0);
    }

    root.addEventListener("mousedown", function (e) {
      beginPan(e.clientX, e.clientY);
    });
    window.addEventListener("mousemove", function (e) {
      if (dragging) movePan(e.clientX, e.clientY);
    });
    window.addEventListener("mouseup", function () {
      if (dragging) endPan();
    });

    // --- Tactile (mobile) : un doigt = glisser, deux doigts = pincer-zoomer ---
    var pinch = null;

    root.addEventListener(
      "touchstart",
      function (e) {
        if (e.touches.length === 2) {
          dragging = false;
          var vb = svg.viewBox.baseVal;
          pinch = {
            dist: touchDistance(e.touches[0], e.touches[1]),
            mid: touchMidpoint(e.touches[0], e.touches[1]),
            vb: { x: vb.x, y: vb.y, width: vb.width, height: vb.height }
          };
        } else if (e.touches.length === 1) {
          pinch = null;
          beginPan(e.touches[0].clientX, e.touches[0].clientY);
        }
      },
      { passive: true }
    );

    root.addEventListener(
      "touchmove",
      function (e) {
        if (e.touches.length === 2 && pinch) {
          e.preventDefault();
          state.suppressClick = true;
          var newDist = touchDistance(e.touches[0], e.touches[1]);
          var factor = pinch.dist / newDist;
          setViewBox(zoomAround(pinch.vb, pinch.mid.x, pinch.mid.y, factor));
        } else if (e.touches.length === 1 && dragging) {
          e.preventDefault();
          movePan(e.touches[0].clientX, e.touches[0].clientY);
        }
      },
      { passive: false }
    );

    root.addEventListener(
      "touchend",
      function (e) {
        if (e.touches.length === 0) {
          pinch = null;
          if (dragging) endPan();
        } else if (e.touches.length === 1) {
          // Passage de deux doigts à un seul : on repart sur un glisser propre.
          pinch = null;
          beginPan(e.touches[0].clientX, e.touches[0].clientY);
          dragMoved = true;
          state.suppressClick = true;
        }
      },
      { passive: true }
    );

    return state;
  }

  // Texte du bouton du popup selon la thématique choisie dans les réglages de la
  // section Shopify. "de"/"en" sont déduits automatiquement du nom du pays par
  // frenchForms() ci-dessous (ex: "de la France", "du Japon", "en France", "au Japon").
  var BUTTON_TEXT = {
    guide: function (forms) { return "Découvrir le guide " + forms.de; },
    geographie: function (forms) { return "Découvrir la géographie " + forms.de; },
    meteo: function (forms) { return "Découvrir le climat " + forms.de; },
    culture: function (forms) { return "Découvrir la culture " + forms.de; },
    gastronomie: function (forms) { return "Découvrir la gastronomie " + forms.de; },
    tradition: function (forms) { return "Découvrir les traditions " + forms.de; },
    activite: function (forms) { return "Découvrir les activités " + forms.en; }
  };

  // Retire les diacritiques (é, è, ê... -> e) sans dépendre d'une regex Unicode :
  // décompose en NFD (lettre + accent séparés) puis ne garde que les caractères
  // hors de la plage des accents combinants (0x0300–0x036F).
  function stripDiacritics(s) {
    if (!s.normalize) return s;
    var decomposed = s.normalize("NFD");
    var result = "";
    for (var i = 0; i < decomposed.length; i++) {
      var point = decomposed.charCodeAt(i);
      if (point < 0x0300 || point > 0x036f) result += decomposed.charAt(i);
    }
    return result;
  }

  /**
   * Déduit "de la France" / "en France" (etc.) à partir du seul nom du pays,
   * selon la règle générale du français :
   *  - le nom commence par une voyelle (ou h muet)  -> "de l'X"   / "en X"
   *  - le nom (son premier mot) se termine par "e"  -> "de la X"  / "en X"
   *  - sinon (masculin, consonne)                   -> "du X"     / "au X"
   * Les cas irréguliers (pluriels, masculins en -e, îles sans article...) sont
   * corrigés via WORLD_MAP_GRAMMAR_EXCEPTIONS dans countries-data.js plutôt que
   * de complexifier cette règle — à n'utiliser qu'en dernier recours.
   */
  function frenchForms(code, label) {
    var exceptions = window.WORLD_MAP_GRAMMAR_EXCEPTIONS || {};
    if (exceptions[code]) return exceptions[code];
    if (!label) return { de: "de " + code.toUpperCase(), en: "en " + code.toUpperCase() };

    var firstWord = stripDiacritics(label.split(/[\s-]/)[0]);
    var startsWithVowel = /^[aeiouyh]/i.test(stripDiacritics(label));
    var endsWithE = /e$/i.test(firstWord);

    if (startsWithVowel) return { de: "de l'" + label, en: "en " + label };
    if (endsWithE) return { de: "de la " + label, en: "en " + label };
    return { de: "du " + label, en: "au " + label };
  }

  /**
   * theme : null/"guide" pour le hub (/pages/<slug>), ou l'une des 6 thématiques
   * ("meteo", "geographie", "culture", "tradition", "gastronomie", "activite")
   * pour /pages/<slug>-<theme>. L'URL, le statut publié et le texte du bouton du
   * popup sont tous dérivés ici, à partir des données déclarées dans
   * countries-data.js — jamais stockés en dur.
   */
  function dataForCode(code, theme) {
    var base = (window.WORLD_MAP_ALL_COUNTRIES && window.WORLD_MAP_ALL_COUNTRIES[code]) || {};
    var slug = window.WORLD_MAP_PUBLISHED_COUNTRIES && window.WORLD_MAP_PUBLISHED_COUNTRIES[code];

    if (!slug) {
      return { label: base.label, published: false, url: "" };
    }

    var url = theme && theme !== "guide" ? "/pages/" + slug + "-" + theme : "/pages/" + slug;
    var forms = frenchForms(code, base.label);
    var buttonTextFor = BUTTON_TEXT[theme] || BUTTON_TEXT.guide;

    return { label: base.label, published: true, url: url, buttonText: buttonTextFor(forms) };
  }

  // --- Popup pays : une seule instance partagée par toute la page, quel que soit
  // le nombre de cartes WorldMap.init() en cours (jamais plusieurs popups à la fois).
  var sharedModal = null;

  function getModal() {
    if (sharedModal) return sharedModal;

    var overlay = document.createElement("div");
    overlay.className = "wm-modal-overlay";
    overlay.innerHTML =
      '<div class="wm-modal" role="dialog" aria-modal="true" aria-labelledby="wm-modal-name">' +
      '<button type="button" class="wm-modal-close" aria-label="Fermer">✕</button>' +
      '<div class="wm-modal-header">' +
      '<span class="wm-modal-icon" aria-hidden="true">🌍</span>' +
      '<h2 class="wm-modal-name" id="wm-modal-name"></h2>' +
      "</div>" +
      '<a class="wm-modal-cta" href="#"></a>' +
      "</div>";
    document.body.appendChild(overlay);

    var modal = overlay.querySelector(".wm-modal");
    var nameEl = overlay.querySelector(".wm-modal-name");
    var ctaEl = overlay.querySelector(".wm-modal-cta");
    var closeBtn = overlay.querySelector(".wm-modal-close");

    var isOpen = false;
    var lastFocused = null;

    function open(data) {
      nameEl.textContent = data.label || data.code.toUpperCase();
      ctaEl.href = data.url;
      ctaEl.textContent = data.buttonText || "Découvrir";

      if (!isOpen) {
        lastFocused = document.activeElement;
        document.body.classList.add("wm-modal-lock");
        overlay.classList.add("wm-modal-open");
        isOpen = true;
        closeBtn.focus();
      }
      // Si déjà ouvert : seul le contenu ci-dessus change, pas de réanimation.
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      overlay.classList.remove("wm-modal-open");
      document.body.classList.remove("wm-modal-lock");
      if (lastFocused && typeof lastFocused.focus === "function") {
        lastFocused.focus();
      }
    }

    closeBtn.addEventListener("click", close);

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen) close();
    });

    sharedModal = { open: open, close: close, isOpen: function () { return isOpen; } };
    return sharedModal;
  }

  /**
   * Le SVG (~1 Mo) dépasse la limite Shopify de 256 Ko pour les fichiers Liquid
   * (snippets/sections/templates), qui n'existe pas pour les Assets .js/.css. Il
   * est donc stocké comme chaîne dans assets/world-map-svg.js (window.WORLD_MAP_SVG)
   * plutôt que fetché séparément — évite toute requête réseau supplémentaire et
   * tout risque de blocage CORS sur le CDN Shopify. Une fois injecté dans le DOM,
   * tout le reste (zoom, popup, couleurs) fonctionne comme avec un SVG inline.
   */
  function initWorldMap(root, theme) {
    if (!root) return;

    var existingSvg = root.querySelector("svg");
    if (existingSvg) {
      setupWorldMap(root, existingSvg, theme);
      return;
    }

    if (!window.WORLD_MAP_SVG) {
      // eslint-disable-next-line no-console
      console.error("WorldMap: world-map-svg.js n'est pas chargé (window.WORLD_MAP_SVG manquant).");
      return;
    }

    root.insertAdjacentHTML("afterbegin", window.WORLD_MAP_SVG);
    var svg = root.querySelector("svg");
    if (svg) setupWorldMap(root, svg, theme);
  }

  function setupWorldMap(root, svg, theme) {
    var zoomState = initZoomPan(root, svg);
    var modal = getModal();

    var tooltip = document.createElement("div");
    tooltip.className = "wm-tooltip";
    root.appendChild(tooltip);

    // Le fichier world-map.svg (Wikimedia BlankMap-World, domaine public) marque
    // chaque territoire par la classe "landxx <code>" (ex: "landxx fr"), portée par
    // des éléments de types différents selon les cas : <path> le plus souvent, mais
    // <g> quand plusieurs îles sont groupées (Japon, Madagascar, Svalbard...), et
    // même <circle> pour les territoires australiens trop petits pour un vrai tracé
    // (Île Christmas, Cocos, Heard-et-McDonald). D'où le sélecteur générique ".landxx"
    // plutôt que "path.landxx" seul.
    //
    // Cas particulier (FR, NL, CN) : le morceau principal porte un code se terminant
    // par "x" (ex: "frx") en plus du code parent ("fr") utilisé comme classe de
    // regroupement — on retombe alors sur le code parent pour matcher countries-data.
    var paths = svg.querySelectorAll(".landxx");

    paths.forEach(function (path) {
      var classes = [];
      path.classList.forEach(function (cls) {
        if (cls !== "landxx") classes.push(cls);
      });
      if (!classes.length) return;

      var code = classes[classes.length - 1];
      if (classes.length >= 2 && code === classes[classes.length - 2] + "x") {
        code = classes[classes.length - 2];
      }

      var data = dataForCode(code, theme);

      path.classList.add("wm-country");

      if (data && data.published && data.url) {
        path.classList.add("wm-published");
      } else {
        path.classList.add("wm-unpublished");
      }

      path.addEventListener("mouseenter", function () {
        path.classList.add("wm-hovered");
        tooltip.textContent = (data && data.label) || code.toUpperCase();
        tooltip.style.opacity = "1";
      });

      path.addEventListener("mousemove", function (e) {
        var rect = root.getBoundingClientRect();
        tooltip.style.left = e.clientX - rect.left + 12 + "px";
        tooltip.style.top = e.clientY - rect.top + 12 + "px";
      });

      path.addEventListener("mouseleave", function () {
        path.classList.remove("wm-hovered");
        tooltip.style.opacity = "0";
      });

      path.addEventListener("click", function () {
        if (zoomState && zoomState.suppressClick) return;
        if (data && data.published && data.url) {
          modal.open({ code: code, label: data.label, url: data.url, buttonText: data.buttonText });
        }
      });
    });

    buildCountryList(root, theme, modal);
  }

  /**
   * Bloc sous la carte : recherche instantanée + liste des pays déjà publiés,
   * triée alphabétiquement (insensible aux accents). Cliquer une ligne ouvre le
   * même popup qu'un clic sur la carte (comportement inchangé) — aucune donnée
   * dupliquée, tout revient à dataForCode() comme pour les tracés du SVG.
   *
   * Ne touche à rien du moteur de carte (zoom, pan, popup) : ne construit que
   * ce bloc, indépendant, réutilisable tel quel sur les 7 pages.
   */
  function buildCountryList(root, theme, modal) {
    var published = window.WORLD_MAP_PUBLISHED_COUNTRIES || {};
    var codes = Object.keys(published);
    if (!codes.length) return;

    var items = codes
      .map(function (code) {
        return { code: code, data: dataForCode(code, theme) };
      })
      .filter(function (item) {
        return item.data.published;
      });

    items.sort(function (a, b) {
      var nameA = stripDiacritics(a.data.label || "").toLowerCase();
      var nameB = stripDiacritics(b.data.label || "").toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });

    var total = items.length;

    // --- Structure -----------------------------------------------------
    var panel = document.createElement("div");
    panel.className = "wm-country-list";

    var header = document.createElement("div");
    header.className = "wm-country-list-header";
    var count = document.createElement("p");
    count.className = "wm-country-list-count";
    header.appendChild(count);
    panel.appendChild(header);

    var searchWrap = document.createElement("div");
    searchWrap.className = "wm-country-search";
    // Icône loupe en SVG inline (pas de dépendance externe) + champ de recherche.
    searchWrap.innerHTML =
      '<svg class="wm-country-search-icon" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<circle cx="8.5" cy="8.5" r="6" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
      '<line x1="13" y1="13" x2="17.5" y2="17.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      "</svg>" +
      '<input type="text" class="wm-country-search-input" placeholder="Rechercher un pays…" autocomplete="off" spellcheck="false" aria-label="Rechercher un pays" />';
    panel.appendChild(searchWrap);
    var searchInput = searchWrap.querySelector(".wm-country-search-input");

    var scroller = document.createElement("div");
    scroller.className = "wm-country-list-scroll";
    var ul = document.createElement("ul");
    scroller.appendChild(ul);
    panel.appendChild(scroller);

    var empty = document.createElement("p");
    empty.className = "wm-country-list-empty";
    empty.textContent = "Aucun pays trouvé.";
    panel.appendChild(empty);

    root.insertAdjacentElement("afterend", panel);

    // --- Lignes ----------------------------------------------------------
    var rows = items.map(function (item) {
      var li = document.createElement("li");
      var button = document.createElement("button");
      button.type = "button";
      button.className = "wm-country-list-item";
      button.textContent = item.data.label;
      // Comportement inchangé : ouvre le popup (croix / clic extérieur / Échap /
      // bouton "Découvrir") exactement comme un clic sur le pays dans la carte.
      button.addEventListener("click", function () {
        modal.open({
          code: item.code,
          label: item.data.label,
          url: item.data.url,
          buttonText: item.data.buttonText
        });
      });
      li.appendChild(button);
      ul.appendChild(li);
      return { li: li, key: stripDiacritics(item.data.label || "").toLowerCase() };
    });

    // --- Recherche instantanée -------------------------------------------
    function render() {
      var query = stripDiacritics(searchInput.value.trim()).toLowerCase();
      var visible = 0;
      rows.forEach(function (row) {
        var match = !query || row.key.indexOf(query) !== -1;
        row.li.classList.toggle("wm-hidden", !match);
        if (match) visible++;
      });
      count.textContent = query ? "Pays (" + visible + " / " + total + ")" : "Pays disponibles (" + total + ")";
      empty.classList.toggle("wm-visible", visible === 0);
    }

    searchInput.addEventListener("input", render);
    render();
  }

  window.WorldMap = { init: initWorldMap };
})(window);
